import React from 'react'
import './sectionDepoimentos.css'
import { FaQuoteLeft } from 'react-icons/fa'

const depoimentos = [
    {
        texto:
            'A Oxfield entregou nossa solução de integração com altíssima qualidade técnica. O código é limpo, bem documentado e a equipe manteve total transparência do início ao fim do projeto.',
        nome: 'Henrique Rodrigues',
        cargo: 'Gerente de TI',
        empresa: 'Landis+Gyr',
        iniciais: 'HR',
        destaque: 'Entrega dentro do prazo',
    },
    {
        texto:
            'Contratamos a Oxfield para desenvolvimento de aplicativos SAP Fiori e o resultado superou nossas expectativas. A solução funciona perfeitamente em qualquer dispositivo e facilitou o dia a dia da nossa equipe.',
        nome: 'Maria Fonseca',
        cargo: 'Diretora de Processos',
        empresa: 'Faber-Castell',
        iniciais: 'MF',
        destaque: 'Produtividade aumentada',
    },
    {
        texto:
            'O diferencial da Oxfield é a seriedade com que tratam a arquitetura do software. Não buscam apenas resolver o problema imediato — eles pensam na manutenção e evolução do sistema a longo prazo.',
        nome: 'Roberto Alves',
        cargo: 'CTO',
        empresa: 'Cliente Oxfield',
        iniciais: 'RA',
        destaque: 'Redução de custos de manutenção',
    },
]

export default function SectionDepoimentos() {
    return (
        <div id="depoimentos" className="container-fluid">
            <div className="container">

                <div className="dep-header" data-aos="fade-up">
                    <label className="tituloSection d-flex justify-content-center">Depoimentos</label>
                    <p className="subTituloSection mt-3">
                        O que nossos clientes dizem
                    </p>
                    <p className="textoSection mt-3">
                        Resultados reais, construídos em parceria com empresas que confiaram na Oxfield
                        para transformar seus processos com tecnologia.
                    </p>
                </div>

                <div className="dep-grid">
                    {depoimentos.map((dep, i) => (
                        <div key={i} className="dep-card" data-aos="fade-up">

                            <span className="dep-highlight">
                                <FaQuoteLeft style={{ fontSize: 10 }} />
                                {dep.destaque}
                            </span>

                            <span className="dep-quote-mark">"</span>
                            <p className="dep-text">{dep.texto}</p>

                            <div className="dep-author">
                                <div className="dep-avatar">{dep.iniciais}</div>
                                <div>
                                    <p className="dep-name">{dep.nome}</p>
                                    <p className="dep-role">{dep.cargo}</p>
                                    <p className="dep-company">{dep.empresa}</p>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}
